export interface IMixpanel {
  defaultProperties: Record<string, unknown>;
  init: () => void;
  trackEvent: (eventName: string, properties?: Record<string, unknown>) => void;
  getDistinctId: () => string | undefined;
  identify: (id: string) => void;
  reset: () => void;
  registerOnce: (properties: Record<string, unknown>) => void;
  register: (properties: Record<string, unknown>) => void;
}

export const mixpanel: IMixpanel = {
  defaultProperties: {
    accessiBeProduct: 'Universal Plugin',
    eventType: 'client-side',
    isReact: true,
    pluginSource: 'CMS Plugin',
  },
  init: () => {
    window.mixpanelInit?.();
  },

  trackEvent: (eventName, properties) => {
    window.mixpanel?.track?.(eventName, properties);
  },
  getDistinctId: () => {
    return window.mixpanel?.get_distinct_id?.();
  },
  identify: (id) => {
    window.mixpanel?.identify?.(id);
  },
  reset: () => {
    window.mixpanel?.reset?.();
  },
  registerOnce(properties) {
    window.mixpanel?.register_once?.(properties);
  },
  register(properties) {
    window.mixpanel?.register?.(properties);
  },
};
